module.exports = __webpack_public_path__ + "img/venmo.9335a178.svg";